$(document).ready(function(){

  // ajout de classe si changement de langue

    // Récupérer la valeur de l'attribut lang
  var langAttributeValue = $('html').attr('lang');

  // Vérifier la valeur de l'attribut lang
  if (langAttributeValue === 'en') {
    // Ajouter une classe pour la version anglaise
    $('body').addClass('js version-anglaise');
  } else if (langAttributeValue === 'it') {
    // Ajouter une classe pour la version italienne
    $('body').addClass('js version-italienne');
  }

// Example


  // setTimeout(function() {
  //   $('.sls-purchase-options-container').css({
  //     'border-radius': '16px',
  //     'background-color': 'white',
  //     'overflow': 'hidden'
  //   });
  // }, 800);


  $('.shopify-challenge__button').addClass('cta-1 clr-brwn');


  setTimeout(function() {
    $('.sls-purchase-options-label').css({
      'display': 'none'
    });
  }, 800);

  setTimeout(function() {
    $('gty-whatsapp-chat-button').css({
      'z-index': '0'
    });
  }, 2000);


  setTimeout(function() {
    $('.cc-color-override-28801235.isense-cc-window').css({
        'z-index': '99991'
    });
  }, 800);

  
  setTimeout(function() {
    $('.related, .related + .media-arrow-container, .related-products__heading, .blog .blog__posts').show();

    // $('.related').css("opacity" , "1");


      /* slick related product */
      $('product-recommendations .related, .blog .blog__posts').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: true,
        dots: false,
        centerMode:false,
        infinite: false,
        centerPadding: "30px",
        prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrow: true,
              prevArrow:".arrow-prev",
              nextArrow:".arrow-next",
              centerMode: true,
              centerPadding: "0px"
            }
          },
          {
            breakpoint: 991,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrow: true,
              prevArrow:".arrow-prev",
              nextArrow:".arrow-next",
              centerMode: true,
              centerPadding: "0px"
            }
          },
        ]
      });
}, 3000);

$('product-recommendations .related, .blog .blog__posts').on('afterChange', function(event, slick, currentSlide){
  var lastSlide = slick.slideCount - 1;
  if(currentSlide === lastSlide){
    $('.slick-next').addClass('slick-disabled');
  } else {
    $('.slick-next').removeClass('slick-disabled');
  }
});
  /* slick related product */


  /* fin slick related product */


  $('.team-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    prevArrow:".prev-team-btn",
    nextArrow:".next-team-btn",
    centerMode: true,
    centerPadding: "0px",
    arrow:true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrow : false,
        }
      }]
  })

  /*chef partenaire*/
  
  $('.slider-wrapper').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: true,
    prevArrow:".arrow-prev",
    nextArrow:".arrow-next",
    centerMode: true,
    centerPadding: "0px",
    responsive: [
  {
    breakpoint: 1500,
    settings: {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrow: true,
      prevArrow:".arrow-prev",
      nextArrow:".arrow-next",
      centerMode: true,
      centerPadding: "0px"
    }
  },
      {
    breakpoint: 1024,
    settings: {
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrow: true,
      prevArrow:".arrow-prev",
      nextArrow:".arrow-next",
      centerMode: true,
      centerPadding: "0px"
    }
  },
      {
    breakpoint: 750,
    settings: {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true,
      centerPadding: '150px',
      slidesToShow: 2,
      autoplay: true,
      autoplaySpeed: 4000,
    }
  },
      {breakpoint: 700,
      settings:{
        centerPadding: '100px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 600,
      settings:{
        centerPadding: '70px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 577,
      settings:{
        centerPadding: '90px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 500,
      settings:{
        centerPadding: '70px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 450,
      settings:{
        centerPadding: '50px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }},
      {breakpoint: 376,
      settings:{
        centerPadding: '30px',
      autoplay: true,
      autoplaySpeed: 2000,
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
      }}
    ]
  });

  
  /* slider collection produit homepage */


  $('.collection-produit-slick').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    // width: 500,
    dots: false,
    responsive : [
    {breakpoint : 1200,
      settings:{
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      // centerPadding: "0px",
      }
    },
    {breakpoint : 1024,
      settings:{
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode:true,
      prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      centerPadding: "0px",
      }
    },
    {breakpoint : 749,
      settings:{
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode:false,
      infinite: false,
      centerPadding: "30px",
      prevArrow: ' <div class="media-prev-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      nextArrow: '<div class="media-next-arrow slick-arrow" style=""><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
      }
    }
    ]
  });


  /* slider product media */

  $('.product__media-list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    appendArrows: $('.media-arrow-container'),
    prevArrow: $('.media-prev-arrow'),
    nextArrow: $('.media-next-arrow')
  });

  /* slider product media >>  PACK TEMPLATE*/

  $('.product-slider-pack').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    appendArrows: $('.media-arrow-container'),
    prevArrow: $('.media-prev-arrow'),
    nextArrow: $('.media-next-arrow')
  });


  /* slider Pro type bloc (contact pro)*/

  

  $('.pro-bloc-1').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    pauseOnFocus: false,
    appendArrows: $('.btn-wrapper-1'),
    prevArrow: $('.prev-team-btn-1'),
    nextArrow: $('.next-team-btn-1')
  });

  $('.pro-bloc-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    pauseOnFocus: false,
    autoplay: true,
    autoplaySpeed: 5500,
    appendArrows: $('.btn-wrapper-2'),
    prevArrow: $('.prev-team-btn-2'),
    nextArrow: $('.next-team-btn-2')
  });


  /* slider Pro type bloc (contact pro)*/




  /* tab menu product desc */

    $('ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');
  
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
  
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

      var spans = document.querySelectorAll('span[data-tab]');
      for (var i = 0; i < spans.length; i++) {
        let spani = spans[i];
        if (tab_id === spani.getAttribute('data-tab')) {
          
          // Ajoutez la classe "current" à l'élément <span> correspondant
          spani.classList.add('current');
        } else {
          // Supprimez la classe "current" des autres éléments <span>
          spani.classList.remove('current');
        }
      }
    });

     /* tab menu product mbl */
  

  $('.description-wrapper .container>span').click(function(){
    var tab_id = $(this).attr('data-tab');

    if ($(this).hasClass('current')) {
      $(this).toggleClass('current');
      $("#"+tab_id).toggleClass('current');
    }
    else{
      $('.description-wrapper span').removeClass('current');
      $('.tab-content').removeClass('current');
      
      $(this).toggleClass('current');
      $("#"+tab_id).toggleClass('current');
    }
  });



  // LIENS SCROLL UP

  var liensAncre = document.querySelectorAll('a[href^="#"]');

  liensAncre.forEach(function (lien) {
    lien.addEventListener("click", function (e) {
      e.preventDefault();
  
      var cibleId = lien.getAttribute("href").substring(1);
      var cible = document.getElementById(cibleId);
  
      if (cible.getAttribute("id") !== "desctiption-produit"){
        if (cible) {

          var position = cible.offsetTop - 150;
  
          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
      }
      else{
        if (window.innerWidth <= 479 ){
          var position = cible.offsetTop - 70;

          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
        else{
          var position = cible.offsetTop - 100;

          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        }
      }
     });
  });

// MENU MAIN LOGO NAVIGATION 




// Vérifiez si l'attribut "open" est présent

var burger = document.getElementById('Details-menu-drawer-container');
isTop = "false";


burger.addEventListener("click", function () {
  var header = document.querySelector(".shopify-section-header-sticky ");


  if (header === null){
    isTop = "true";

    var header = document.querySelector('.section-header')
  }

  var element = document.querySelector(".header__icon--menu");
  var montag = element.getAttribute("aria-expanded")  ;
  //console.log("mon tag : "+ montag);
  if (isTop == "true"){
    if (montag == "true") {

      header.classList.add("shopify-section-header-sticky");
    }
    else{
      header.classList.remove("shopify-section-header-sticky");    
      isTop = "false";
    }
  }
});
    

// Page Produit -> Alma (transform text en span)


function wrapWordsInSpans() {
  var textContainer = document.querySelector(".almatext");
  var text = textContainer.textContent;
  //console.log(text)
  var words = text.split(/\s+/); // Utilise une expression régulière pour diviser le texte par espaces

  for (let index = 0; index < words.length; index++) {
    //console.log(words[index])
    if (words[index] == "") {
      words.splice(index,1)
    }    
    if (words[index] == " ") {
      words.splice(index,1)
    }
  };
  // console.log(words)

  var newHTML = "";
  words.forEach(function(word, index) {
    // console.log(index)
    newHTML += "<span>" + word + "</span>";

    // Ajoute un espace entre les balises <span> pour préserver l'espacement
    if (index < words.length - 1) {
      newHTML += " ";
    }
  });

  textContainer.innerHTML = newHTML;
  
  $('.almatext').append($(".alma-img"))
};

          
  if (document.body.classList.contains("product-p")) {
  wrapWordsInSpans();
  };


  /* injection html */
$(".shopify-challenge__button").wrap("<div></div>");
$(".shopify-challenge__button").append('<span> <svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" width="18.141" height="10.334" viewBox="0 0 18.141 10.334"> <g id="right-arrow_2_" data-name="right-arrow (2)" transform="translate(-5.302 -128.945)"> <g id="Groupe_100" data-name="Groupe 100" transform="translate(5.802 129.445)"> <path id="Tracé_33" data-name="Tracé 33" d="M16.981,131.738h0L13.1,127.517a.367.367,0,0,0-.548-.046.448.448,0,0,0-.042.6.406.406,0,0,0,.042.046l3.221,3.5H.388a.424.424,0,0,0,0,.844H15.769l-3.221,3.5a.448.448,0,0,0-.042.6.367.367,0,0,0,.548.046.4.4,0,0,0,.042-.046l3.885-4.221A.448.448,0,0,0,16.981,131.738Z" transform="translate(0 -127.369)" stroke="black" stroke-width="1"/> </g> </g> </svg> </span>');
$(".shopify-challenge__button").parent().attr("class","cta-1 clr-brwn");


/* avis clients — carrousel Fera (étoiles jaunes, droits libres) */

var AVIS_CLIENTS_FLOWER_URL =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23F5B400'><path d='M12 2.5l2.95 6.36 6.8.62-5.14 4.68 1.52 6.84L12 17.77l-6.13 3.23 1.52-6.84L2.25 9.48l6.8-.62L12 2.5z'/></svg>";

function getAvisClientsStarsRoot(ratingContainer) {
  if (!ratingContainer) return null;
  if (ratingContainer.classList && ratingContainer.classList.contains("fera-stars")) {
    return ratingContainer;
  }
  return (
    ratingContainer.querySelector(".fera-stars") ||
    ratingContainer.closest(".fera-stars")
  );
}

function getAvisClientsRating(reviewEl, ratingContainer) {
  if (reviewEl && reviewEl.dataset.lucangeliRating) {
    var stored = parseInt(reviewEl.dataset.lucangeliRating, 10);
    if (stored >= 1 && stored <= 5) return stored;
  }

  var starsRoot = getAvisClientsStarsRoot(ratingContainer);
  if (starsRoot) {
    var dataRating = starsRoot.getAttribute("data-rating");
    if (dataRating) {
      var fromData = Math.round(parseFloat(dataRating));
      if (fromData >= 1 && fromData <= 5) return fromData;
    }
  }

  if (ratingContainer) {
    var srOnly =
      ratingContainer.querySelector('.fera--srOnly[itemprop="ratingValue"]') ||
      ratingContainer.querySelector(".fera--srOnly");
    if (srOnly && srOnly.textContent) {
      var fromSr = Math.round(parseFloat(srOnly.textContent.trim()));
      if (fromSr >= 1 && fromSr <= 5) return fromSr;
    }
  }

  if (reviewEl) {
    var reviewRating =
      reviewEl.getAttribute("data-rating") || reviewEl.getAttribute("data-fera-rating-value");
    if (reviewRating) {
      var fromReview = Math.round(parseFloat(reviewRating));
      if (fromReview >= 1 && fromReview <= 5) return fromReview;
    }
  }

  var starsRating = ratingContainer && ratingContainer.querySelector(".fera-stars-rating");
  if (starsRating) {
    var widthStyle = starsRating.style.width || "";
    if (widthStyle.indexOf("%") === -1 && window.getComputedStyle) {
      widthStyle = window.getComputedStyle(starsRating).width;
    }
    if (String(widthStyle).indexOf("%") !== -1) {
      var pct = parseFloat(widthStyle);
      if (pct > 0) return Math.max(1, Math.min(5, Math.round(pct / 20)));
    }
  }

  return 5;
}

function replaceAvisClientsStarsWithFlowers(ratingContainer, forcedRating) {
  if (!ratingContainer) return;

  var reviewEl = ratingContainer.closest(".fera-review, .fera-allReviews-review");
  var rating = Math.max(
    1,
    Math.min(
      5,
      forcedRating != null ? forcedRating : getAvisClientsRating(reviewEl, ratingContainer)
    )
  );

  if (reviewEl) reviewEl.dataset.lucangeliRating = String(rating);

  var existing = ratingContainer.querySelector(".avis-clients-stars");
  if (
    existing &&
    existing.childElementCount === rating &&
    ratingContainer.dataset.lucangeliRating === String(rating)
  ) {
    return;
  }

  var starsWrap = document.createElement("div");
  starsWrap.className = "avis-clients-stars";
  starsWrap.setAttribute("data-rating", String(rating));
  starsWrap.setAttribute("aria-label", rating + " sur 5");

  for (var i = 0; i < rating; i++) {
    var img = document.createElement("img");
    img.src = AVIS_CLIENTS_FLOWER_URL;
    img.alt = "";
    img.width = 22;
    img.loading = "lazy";
    starsWrap.appendChild(img);
  }

  ratingContainer.innerHTML = "";
  ratingContainer.appendChild(starsWrap);
  ratingContainer.dataset.lucangeliFlowers = "1";
  ratingContainer.dataset.lucangeliRating = String(rating);
}

function getAvisClientsBodySource(contentCol) {
  var truncation = contentCol.querySelector(".fera-truncation");
  if (truncation) {
    return (
      truncation.querySelector(".fera-truncation-truncatedText") ||
      truncation.querySelector(".fera-review-body") ||
      truncation
    );
  }
  return contentCol.querySelector(".fera-review-body");
}

function layoutAvisClientsCard(reviewEl) {
  if (!reviewEl || reviewEl.dataset.lucangeliLayout === "3") return;

  var contentCol = reviewEl.querySelector(".fera-review-content-col");
  if (!contentCol) return;

  var ratingBlock = contentCol.querySelector(".fera-review-rating");
  if (!ratingBlock) return;

  var capturedRating = getAvisClientsRating(reviewEl, ratingBlock);
  reviewEl.dataset.lucangeliRating = String(capturedRating);

  var dateEl = contentCol.querySelector(".fera-review-date");
  var bodySource = getAvisClientsBodySource(contentCol);
  var customerEl = contentCol.querySelector(".fera-customer-display");
  var locationEl =
    contentCol.querySelector(".fera-customer-display-location") ||
    (customerEl && customerEl.querySelector(".fera-customer-display-location"));

  var layout = document.createElement("div");
  layout.className = "avis-card__layout";

  var header = document.createElement("div");
  header.className = "avis-card__header";

  var flowersCol = document.createElement("div");
  flowersCol.className = "avis-card__flowers-col";
  flowersCol.appendChild(ratingBlock);
  header.appendChild(flowersCol);

  if (dateEl) {
    dateEl.classList.add("avis-card__date");
    header.appendChild(dateEl);
  }

  layout.appendChild(header);

  if (bodySource) {
    var bodyWrap = document.createElement("div");
    bodyWrap.className = "avis-card__body";
    bodyWrap.textContent = bodySource.textContent.trim();
    layout.appendChild(bodyWrap);
  }

  if (customerEl || locationEl) {
    var footer = document.createElement("div");
    footer.className = "avis-card__footer";

    if (customerEl) {
      customerEl.classList.add("avis-card__name");
      footer.appendChild(customerEl);
    }

    if (locationEl && locationEl.textContent.trim()) {
      locationEl.classList.add("avis-card__location");
      if (!customerEl || !customerEl.contains(locationEl)) {
        footer.appendChild(locationEl);
      }
    }

    layout.appendChild(footer);
  }

  contentCol.innerHTML = "";
  contentCol.appendChild(layout);
  reviewEl.dataset.lucangeliLayout = "3";

  replaceAvisClientsStarsWithFlowers(
    contentCol.querySelector(".fera-review-rating"),
    capturedRating
  );
}

function initAvisClientsFera() {
  var root = document.querySelector(".section-avis-clients");
  if (!root) return;

  root.querySelectorAll(".fera-review, .fera-allReviews-review").forEach(function (reviewEl) {
    layoutAvisClientsCard(reviewEl);
  });

  root.querySelectorAll(".fera-review-rating").forEach(function (el) {
    var reviewEl = el.closest(".fera-review, .fera-allReviews-review");
    var forced =
      reviewEl && reviewEl.dataset.lucangeliRating
        ? parseInt(reviewEl.dataset.lucangeliRating, 10)
        : null;
    replaceAvisClientsStarsWithFlowers(el, forced);
  });
}

function updateAvisClientsArrowCenter(root) {
  /* Centre verticalement les flèches du carrousel sur la zone des reviews.

     Structure Fera : .fera-testimonialCarousel-nav hérite de .fera-media-nav,
     qui est position:absolute / height:0 / align-items:center / flex
     justify-content:space-between. Les carets ne sont PAS absolus : ce sont
     des flex items, centrés naturellement sur la ligne médiane de la nav
     (qui est sa seule "ligne" puisque height = 0).

     Donc pour aligner les flèches sur le centre des cartes, il suffit de
     positionner la nav elle-même à ce Y, et les flex items se centreront
     automatiquement dessus. On écrit `top` inline !important sur la nav, en
     remplaçant le `bottom: 35%` par défaut de Fera. */
  if (!root) return;
  var widget = root.querySelector(".fera-testimonialCarousel-widget");
  var nav = root.querySelector(".fera-testimonialCarousel-nav");
  var card = root.querySelector(".fera-review");
  if (!widget || !nav || !card) return;
  var widgetRect = widget.getBoundingClientRect();
  var cardRect = card.getBoundingClientRect();
  if (!cardRect.height || !widgetRect.height) return;
  var centerY = cardRect.top - widgetRect.top + cardRect.height / 2;
  if (!isFinite(centerY) || centerY <= 0) return;
  nav.style.setProperty("top", centerY + "px", "important");
  nav.style.setProperty("bottom", "auto", "important");
}

function tuneAvisClientsCarousel(root) {
  updateAvisClientsArrowCenter(root);
}

function watchAvisClientsFera() {
  var root = document.querySelector(".section-avis-clients");
  if (!root) return;
  initAvisClientsFera();
  tuneAvisClientsCarousel(root);
  if (typeof MutationObserver === "undefined") return;
  if (root.dataset.lucangeliObserver === "1") return;
  root.dataset.lucangeliObserver = "1";
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      initAvisClientsFera();
      tuneAvisClientsCarousel(root);
    }, 120);
  });
  observer.observe(root, { childList: true, subtree: true });

  if (typeof window !== "undefined" && !window.__lucangeliAvisResize) {
    window.__lucangeliAvisResize = true;
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateAvisClientsArrowCenter(root);
      }, 80);
    });
  }
}

function initAvisClientsModal(modal) {
  if (!modal) return;

  modal.querySelectorAll(".fera-review, .fera-allReviews-review").forEach(function (reviewEl) {
    layoutAvisClientsCard(reviewEl);
  });

  modal.querySelectorAll(".fera-review-rating").forEach(function (el) {
    var reviewEl = el.closest(".fera-review, .fera-allReviews-review");
    var forced =
      reviewEl && reviewEl.dataset.lucangeliRating
        ? parseInt(reviewEl.dataset.lucangeliRating, 10)
        : null;
    replaceAvisClientsStarsWithFlowers(el, forced);
  });

  modal
    .querySelectorAll(
      ".fera-customer-modal-content-info .fera-stars, " +
        ".fera-customer-modal-content-info .fera-averageRating-average-stars, " +
        ".fera-customer-modal-content-info .fera-customer-details-rating-average"
    )
    .forEach(function (el) {
      var inner =
        el.classList && el.classList.contains("fera-stars")
          ? el
          : el.querySelector(".fera-averageRating-average-stars") ||
            el.querySelector(".fera-stars");
      replaceAvisClientsStarsWithFlowers(inner || el);
    });
}

function watchAvisClientsModals() {
  if (typeof MutationObserver === "undefined") return;
  if (document.body.dataset.lucangeliModalObs === "1") return;
  document.body.dataset.lucangeliModalObs = "1";
  var debounce;
  new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      document
        .querySelectorAll(".fera-modal-dialog-container")
        .forEach(initAvisClientsModal);
    }, 80);
  }).observe(document.body, { childList: true, subtree: true });
}

watchAvisClientsFera();
watchAvisClientsModals();
setTimeout(function () {
  var root = document.querySelector(".section-avis-clients");
  initAvisClientsFera();
  tuneAvisClientsCarousel(root);
}, 1500);
setTimeout(function () {
  var root = document.querySelector(".section-avis-clients");
  initAvisClientsFera();
  tuneAvisClientsCarousel(root);
}, 3500);

/* avis clients (ancien widget grille — Trustpilot) */

setTimeout(popUP, 2000);

function popUP() {
  if (document.querySelector(".section-avis-clients .fera-testimonialCarousel-widget")) return;
  $(".fera-allReviews-heading-col1").prepend("<div class='avis-trust-wrapper'> <p class='avis-text'> Avis certifiés par </p> <img src='https://cdn.shopify.com/s/files/1/0755/1575/6853/files/Trustpilot_Logo__2022__svg.png?v=1686576971'> </div>");
  
  // VERSION ANGLAISE -> RETOUR PRODUITS 
  if (document.body.classList.contains("version-anglaise")) {
    if (document.querySelector(".avis-text") !== null) {
      var review = document.querySelector(".avis-text");
      review.innerText = "Certified trust from";
    };
  };

  // VERSION Italienne -> RETOUR PRODUITS 
  if (document.body.classList.contains("version-italienne")) {
    if (document.querySelector(".avis-text") !== null) {
      var review = document.querySelector(".avis-text");
      review.innerText = "pareri certificati da";
    };
  };
}


//var $date = $('.fera-allReviews-review:nth-child(1) .fera-allReviews-review-date');
//var $pp = $('.fera-allReviews-review:nth-child(1) .fera-allReviews-review-customer');
//$('.fera-allReviews-review:nth-child(1)').find($pp).insertAfter($date);

/*
      $(".reviews div").on("click", function(){
setTimeout(popUP, 2000);
  })
  $(".page-item a").on("click", function(){
setTimeout(popUP, 2000);
  })
*/

  /*detection input text focus unfocus */

    // Sélectionnez votre champ de texte par son ID
var $monInput = $("#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd");

// Ajoutez un gestionnaire d'événement pour l'événement keyup
$monInput.on("keyup", function() {
    // Vérifiez si le champ de texte est vide ou non
    if ($monInput.val().trim() !== "") {
        $('#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd + .field__label').hide();
    } else {
        $('#NewsletterForm--sections--18838706880821__d41e9ec9-cf0a-4580-b18b-3119351d42bd + .field__label').show();
    }
});
  
// jquery : active menu underline

$(".header__active-menu-item").parent().addClass("active-header")

// =========================================================
  
// PRENDRE L'URL
  function getCurrentURL () {
  return window.location.href
  };

  const url = getCurrentURL();

// SUPPRIME BOUTTON (RETOUR PRODUIT) SUR PAGE COLLECTION 
  console.log(url);
  if (url.includes("nos-produits-lucangeli")) {
      if (document.querySelector(".back-collection") !== null) {
        var collink = document.querySelector(".back-collection");
        collink.style.display = "none";
    };
  };


    // VERSION ANGLAISE -> Voir plus (product)
  if (document.body.classList.contains("version-anglaise")) {
    if (document.querySelector(".voir-plus-text") !== null) {
      var seemore = document.querySelector(".voir-plus-text");
      seemore.innerText = "See more";
    };
  };

  // VERSION Italienne -> Voir plus (product)
  if (document.body.classList.contains("version-italienne")) {
    if (document.querySelector(".voir-plus-text") !== null) {
      var seemore = document.querySelector(".voir-plus-text");
      seemore.innerText = "Mostra altri";
    };
  };

// // ==========================================================

//       // VERSION ANGLAISE -> POCHON
//   if (document.body.classList.contains("version-anglaise")) {
//     if (document.querySelector(".pochon-text") !== null) {
//       var pochon = document.querySelector(".pochon-text");
//       pochon.innerText = "Gift bag?";
//     };
//   };

//   // VERSION Italienne -> POCHON
//   if (document.body.classList.contains("version-italienne")) {
//     if (document.querySelector(".pochon-text") !== null) {
//       var pochon = document.querySelector(".pochon-text");
//       pochon.innerText = "sacchetto regalo ?";
//     };
//   };
  
// // ============================================================

// // VERSION ANGLAISE -> VOIR Plus (Produit) 
//   if (document.body.classList.contains("version-anglaise")) {
//     if (document.querySelector(".perso-picto") !== null) {
//       var perso = document.getElementsByClassName("perso-picto");
//       for(var i=0; i< perso.length; i++){
//       perso[i].innerText = "customizable";
//       };
//     };
//   };

// // VERSION ITALIENNE -> PERSONNALISABLER
//   if (document.body.classList.contains("version-italienne")) {
//     if (document.querySelector(".perso-picto") !== null) {
//       var perso = document.getElementsByClassName("perso-picto");
//       for(var i=0; i< perso.length; i++){
//       perso[i].innerText = "personalizzabile";
//       };
//     };
//   };
// ==================================================================

}); 


// iframe video

// Get element
var youtubeEmbedElement = document.getElementById("youtubeEmbed");

// Add YouTube API script
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
var videoId = youtubeEmbedElement.dataset.videoId;
var startSeconds = 0;
// var endSeconds = 210;

onYouTubeIframeAPIReady = function () {
  player = new YT.Player("youtubeEmbed", {
    videoId: videoId, // YouTube Video ID
    playerVars: {
      autoplay: 1, // Auto-play the video on load
      autohide: 1, // Hide video controls when playing
      disablekb: 1,
      controls: 0, // Hide pause/play buttons in player
      showinfo: 0, // Hide the video title
      modestbranding: 1, // Hide the Youtube Logo
      loop: 1, // Run the video in a loop
      fs: 0, // Hide the full screen button
      rel: 0,
      enablejsapi: 1,
      modestbranding: 1,
      vq: 'hd1080',
      start: startSeconds
    },
    events: {
      onReady: function (e) {
        e.target.mute();
        e.target.playVideo();
      },
      onStateChange: function (e) {
        if (e.data === YT.PlayerState.PLAYING) {
          document.getElementById("youtubeEmbed").classList.add("loaded");
        }

        if (e.data === YT.PlayerState.ENDED) {
          // Loop from starting point
          player.seekTo(startSeconds);
        }
      }
    }
  });
};
